(function () {
  // Shrinks a heading's font size while its longest word is wider than the box it sits in.
  // Markup: a box with [data-heading-fit] around one or more .theme-content-heading elements
  // (component-heading-fit.css keeps their words whole). Runs once per width change of the
  // box, never per frame, and only touches headings that do not fit: the others keep their size.
  // Printed by every section that uses it; the editor re-render (section:load) observes the new box.
  if (window.AxiomHeadingFitLoaded) return;
  window.AxiomHeadingFitLoaded = true;
  if (!('ResizeObserver' in window)) return;

  var SCOPE_SELECTOR = '[data-heading-fit]';
  var HEADING_SELECTOR = '.theme-content-heading';
  var FLOOR = 0.6; // smallest size, as a share of the heading's set size
  var STEP = 0.95;
  var widths = new WeakMap();
  var observed = new Set();

  function availableWidth(scope) {
    var style = window.getComputedStyle(scope);
    return scope.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
  }

  function setSize(heading, size) {
    heading.style.fontSize = size + 'px';
    return heading.getBoundingClientRect().width;
  }

  function fitHeading(heading, available) {
    // Back to the set size (the inline heading scale, if any) before measuring.
    if (heading.__headingFitSize === undefined) heading.__headingFitSize = heading.style.fontSize;
    heading.style.fontSize = heading.__headingFitSize;
    heading.removeAttribute('data-heading-fit-state');

    // The heading is never narrower than its longest word, so wider than the box = a word does not fit.
    var width = heading.getBoundingClientRect().width;
    if (width <= available + 0.5) return;

    var base = parseFloat(window.getComputedStyle(heading).fontSize);
    var floor = base * FLOOR;
    // Text width follows the font size, so one proportional step usually fits; the loop catches rounding.
    var size = Math.max(floor, Math.floor(base * (available / width) * 10) / 10);
    width = setSize(heading, size);
    while (width > available + 0.5 && size > floor) {
      size = Math.max(floor, size * STEP);
      width = setSize(heading, size);
    }
    heading.setAttribute('data-heading-fit-state', width > available + 0.5 ? 'break' : 'fit');
  }

  function fitScope(scope) {
    var available = availableWidth(scope);
    if (available <= 0) return;
    scope.querySelectorAll(HEADING_SELECTOR).forEach(function (heading) {
      fitHeading(heading, available);
    });
  }

  var observer = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var width = Math.round(entry.contentRect.width * 10) / 10;
      // Our own font change only alters the box height: skip until the width changes.
      if (widths.get(entry.target) === width) return;
      widths.set(entry.target, width);
      fitScope(entry.target);
    });
  });

  function observe(root) {
    if (!root || !root.querySelectorAll) return;
    var scopes = root.matches && root.matches(SCOPE_SELECTOR) ? [root] : root.querySelectorAll(SCOPE_SELECTOR);
    Array.prototype.forEach.call(scopes, function (scope) {
      if (observed.has(scope)) return;
      observed.add(scope);
      observer.observe(scope);
    });
  }

  function unobserve(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SCOPE_SELECTOR).forEach(function (scope) {
      observer.unobserve(scope);
      observed.delete(scope);
      widths.delete(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  // A web font that finishes loading changes word widths without resizing the box.
  if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', function () {
      observed.forEach(fitScope);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unobserve(event.target);
  });
})();
